<template>
  <div class="development">
    <div class="title">发展历程</div>
    <Timeline>
      <Timeline-item v-for="(item, index) in developmentList" :key="index">
        <div class="time">{{ item.year }}</div>
        <div class="content">{{ item.content }}</div>
      </Timeline-item>
    </Timeline>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      developmentList: [],
    };
  },
  methods: {
    reqDevelopment() {
      axios.get("./data.json").then((res) => {
        this.developmentList = res.data.development;
      });
    },
  },
  mounted() {
    this.reqDevelopment();
  },
};
</script>

<style>
.time,
.content {
  line-height: 28px;
}
.title {
  font-size: 28px;
  text-align: center;
  padding: 20px 0;
}
</style>
